
const initialState = {
  isFetchingGetAllFormData: false,
  isFetchingDates: false,
  isFetchingRespondantFillingOptions: false,
  isMarriedBefore: false,
  isFetchingDenyingDissolvingMarriage: false,
  isFetchingRespondantFiledPetition: false,
  isFetchingAddForms: false,
  isFetchingAddSppousalSupport: false,
  isFetchingAddCustody: false,
  isFetchingFormerLastName: false,
  isFetchingChildAge: false,
  isFetchingChildResidence: false,
  isUpdatingData: false,
  isFetchingCustodyTypes: false,
  isFetchingCustodySubtypes: false,
  isFetchingDPDetails: false,
  fillingOption: [],
  states: [],
  isFetchingStates: false, //DONE
  divorceLsBasis: [],
  isFetchingdivorceLsBasis: false,
  nullityBasis: [],
  divorceId: "",
  isFetchingNullityBasis: false,
  isFetchingResponseResidence :false,


  residence: "-1",

  //Respondent Petition

  respondantDissolutionOfMarriage: {
    no: {
      respondantDissolutionOfMarriageStatus: "-1",
    },
    yes: {
      caseNo: "",
    },
  },

  //RESTORE FORMER LASTNAME
  restoreFormerLastName: {
    no: {
      restore_name_res: "-1",
    },
    yes: {
      name_petitioner: "",
      name_response: "",
    },
  },
  //COMMUNITY PROPERTY
  communityProperty: {
    no: {
      communityPropertyStatus: "-1",
    },
    yes: {
      useLanguage: "-1",
    },
  },
  //SEPARATE PROPERTY
  separateProperty: {
    no: {
      separatePropertyStatus: "-1",
    },
    yes: {
      useLanguage: "-1",
    },
  },

  //SPOUSAL SUPPORT
  spousalSupport: {
    spousalSupportPayable: {
      spousalSupportPayableStatus: "-1",
    },
    spousalSupportTerminate: {
      spousalSupportTerminateStatus: "-1",
    },
    spousalSupportReserve: {
      spousalSupportReserveStatus: "-1",
    },
  },
  //Custody Rights
  custodyRights: {
    custodyRightsStatus: "-1",
  },
  //Domestic Voilence
  domesticVoilence: {
    domesticVoilenceStatus: "-1",
  },

  //CASE
  childCustodyCase: {
    childCustodyCaseStatus: "-1",
  },
  //custody
  childCustody: {
    legalCustody: "-1",
    physicalCustody: "-1",
    childVisitation: "-1",
    additionalForm : [],
  },

  underAge18 :"-1",

  //DATES
  dates: {
    dateOfMarriage: "",
    dateOfSeparation: "",
    dateOfDP: "",
    dateOfDPSeparation: "",
  },

  //Filling Option
  filingOption: {
    filingOptionStatus: "-1",
    divorce: {
      divorcedTypes: "-1",
    },
    legalSeparation: {
      legalSeparationTypes: "-1",
    },
    nulity: "-1",
  },

  //Dissolve Status
  dissolveMarriage: {
    dissolveMarriageStatus: "-1",
  },
  //Never Married
  marriedBefore: {
    marriedBeforeStatus: "-1",
  },

  domesticPartnership: {
    domesticPartnershipStatus:"-1",
    establishedInCalifornia: {
      establishedInCaliforniaStatus:"-1",
        californiaJurisdiction:{
          petitionerState: 6,
          respondentState: 6
        }
    }
  },



  //PetitionerDETAILS
  petitionerDetails: {
    firstName: "",
    lastName: "",
    streetAddress: "",
    city: "",
    zip: "",
    state: "6",
    telephone: "",
    email: "",
  },
  //RespondantDETAILS
  respondentDetails: {
    firstName: "",
    lastName: "",
    streetAddress: "asdadsa",
    city: "",
    zip: "",
    state: "6",
    telephone: "",
    email: "",
  },
  //CourtDETAILS
  court: {
    courtStreetAddress: "",
    courtMailingAddress: "",
    city: "",
    zip: "",
    branch: "0",
    county: "",
  },

  //Filled Petition

  dissolutionOfMarriage: {
    no: {
      dissolutionOfMarriageStatus: "-1",
    },
    yes: {
      caseNumber: "",
    },
    isPetitioner: "",
  },
};

const responsePacketReducer = (state = initialState, action) => {
  switch (action.type) {
    //ALL FORM DATA
    case "REQUEST_RESPONDENT_FORM_DATA":
      return { ...state, isFetchingGetAllFormData: true };
    case "SUCCESS_RESPONDENT_FORM_DATA":
      return {
        ...state,
        isFetchingGetAllFormData: false,
        respondantDissolutionOfMarriage:{
          no: {
            respondantDissolutionOfMarriageStatus:
              action.payload.data.respondantDissolutionOfMarriage.no
                .respondantDissolutionOfMarriageStatus,
          },
          yes: {
            caseNo:
              action.payload.data.respondantDissolutionOfMarriage.yes.caseNo,
          },
        },
        
        residence: action.payload.data.residence,

        //RESTORE FORMER LASTNAME
        restoreFormerLastName: {
          no: {
            restore_name_res:
              action.payload.data.restoreFormerLastName.no
                .restore_name_res,
          },
          yes: {
            name_petitioner: action.payload.data.restoreFormerLastName.yes.name_petitioner,
            name_response: action.payload.data.restoreFormerLastName.yes.name_response,
          },
        },
        //COMMUNITY PROPERTY
        communityProperty: {
          no: {
            communityPropertyStatus:
              action.payload.data.communityProperty.no.communityPropertyStatus,
          },
          yes: {
            useLanguage: action.payload.data.communityProperty.yes.useLanguage,
          },
        },
        //SEPARATE PROPERTY
        separateProperty: {
          no: {
            separatePropertyStatus:
              action.payload.data.separateProperty.no.separatePropertyStatus,
          },
          yes: {
            useLanguage: action.payload.data.separateProperty.yes.useLanguage,
          },
        },

        //SPOUSAL SUPPORT
        spousalSupport: {
          spousalSupportPayable: {
            spousalSupportPayableStatus:
              action.payload.data.spousalSupport.spousalSupportPayable
                .spousalSupportPayableStatus,
          },
          spousalSupportTerminate: {
            spousalSupportTerminateStatus:
              action.payload.data.spousalSupport.spousalSupportTerminate
                .spousalSupportTerminateStatus,
          },
          spousalSupportReserve: {
            spousalSupportReserveStatus:
              action.payload.data.spousalSupport.spousalSupportReserve
                .spousalSupportReserveStatus,
          },
        },

        //Custody Rights
        custodyRights: {
          custodyRightsStatus:
            action.payload.data.custodyRights.custodyRightsStatus,
        },
        //Domestic Voilence
        domesticVoilence: {
          domesticVoilenceStatus:
            action.payload.data.domesticVoilence.domesticVoilenceStatus,
        },

        //CASE
        childCustodyCase: {
          childCustodyCaseStatus:
            action.payload.data.childCustodyCase.childCustodyCaseStatus,
        },
        //custody
        childCustody: {
          legalCustody: action.payload.data.childCustody.legalCustody,
          physicalCustody: action.payload.data.childCustody.physicalCustody,
          childVisitation: action.payload.data.childCustody.childVisitation,
          additionalForm: action.payload.data.childCustody.additionalForm,
        },
        
        underAge18 : action.payload.data.underAge18,

        //DATES
        dates: {
          dateOfMarriage: action.payload.data.dates.dateOfMarriage,
          dateOfSeparation: action.payload.data.dates.dateOfSeparation,
          dateOfDP: action.payload.data.dates.dateOfDP,
          dateOfDPSeparation: action.payload.data.dates.dateOfDPSeparation,
        },

        //Filling Option
        filingOption: {
          filingOptionStatus:
            action.payload.data.filingOption.filingOptionStatus,
          divorce: {
            divorcedTypes:
              action.payload.data.filingOption.divorce.divorcedTypes,
          },
          legalSeparation: {
            legalSeparationTypes:
              action.payload.data.filingOption.legalSeparation
                .legalSeparationTypes,
          },
          nulity: action.payload.data.filingOption.nulity,
        },

        //Dissolve Status
        dissolveMarriage: {
          dissolveMarriageStatus:
            action.payload.data.dissolveMarriage.dissolveMarriageStatus,
        },
        //Never Married
        marriedBefore: {
          marriedBeforeStatus:
            action.payload.data.marriedBefore.marriedBeforeStatus,
        },

        // Domestic Partnerhip Stepper

        domesticPartnership: {
          domesticPartnershipStatus:action.payload.data.domesticPartnership.domesticPartnershipStatus,
          establishedInCalifornia: {
            establishedInCaliforniaStatus:action.payload.data.domesticPartnership.establishedInCalifornia.establishedInCaliforniaStatus,
              californiaJurisdiction:{
                petitionerState:action.payload.data.domesticPartnership.establishedInCalifornia.californiaJurisdiction.petitionerState,
                respondentState:action.payload.data.domesticPartnership.establishedInCalifornia.californiaJurisdiction.respondentState
              }
          }
        },


        //PetitionerDETAILS
        petitionerDetails: {
          firstName: action.payload.data.petitionerDetails.firstName,
          lastName: action.payload.data.petitionerDetails.lastName,
          streetAddress: action.payload.data.petitionerDetails.streetAddress,
          city: action.payload.data.petitionerDetails.city,
          zip: action.payload.data.petitionerDetails.zip,
          state: action.payload.data.petitionerDetails.state,
          telephone: action.payload.data.petitionerDetails.telephone,
          email: action.payload.data.petitionerDetails.email,
        },
        respondentDetails: {
          firstName: action.payload.data.respondentDetails.firstName,
          lastName: action.payload.data.respondentDetails.lastName,
          streetAddress: action.payload.data.respondentDetails.streetAddress,
          city: action.payload.data.respondentDetails.city,
          zip: action.payload.data.respondentDetails.zip,
          state: action.payload.data.respondentDetails.state,
          telephone: action.payload.data.respondentDetails.telephone,
          email: action.payload.data.respondentDetails.email,
        },
        court: {
          courtStreetAddress: action.payload.data.court.courtStreetAddress,
          courtMailingAddress: action.payload.data.court.courtMailingAddress,
          city: action.payload.data.court.city,
          zip: action.payload.data.court.zip,
          branch: action.payload.data.court.branch,
          county: action.payload.data.court.county,
        },
        //Filled Petition

        dissolutionOfMarriage: {
          no: {
            dissolutionOfMarriageStatus:
              action.payload.data.dissolutionOfMarriage.no
                .dissolutionOfMarriageStatus,
          },
          yes: {
            caseNumber:
              action.payload.data.dissolutionOfMarriage.yes.caseNumber,
          },
          isPetitioner: action.payload.data.dissolutionOfMarriage.isPetitioner,
        },
      };
    case "ERROR_RESPONDENT_FORM_DATA":
      return { ...state, isFetchingGetAllFormData: false };


      //RESIDENCE
    case "REQUEST_RESPONSE_RESIDENCE":
      return { ...state, isFetchingResponseResidence: true };
    case "SUCCESS_RESPONSE_RESIDENCE":
      return {
        ...state,
        isFetchingResponseResidence: false,
        residence: action.payload.resideCalifornia,
      };

    case "ERROR_RESPONSE_RESIDENCE":
      return { ...state, isFetchingResponseResidence: false };

    //COMMUNITY PROPERTY
    case "REQUEST_COMMUNITY_PROPERTY":
      return { ...state, isFetchingCommunityProperty: true };
    case "SUCCESS_COMMUNITY_PROPERTY":
      return {
        ...state,
        communityProperty: {
          no: {
            communityPropertyStatus: action.payload.communityProperty,
          },
          yes: {
            useLanguage: action.payload.communityLanguage,
          },
        },
        isFetchingCommunityProperty: false,
      };

    case "ERROR_COMMUNITY_PROPERTY":
      return {
        ...state,
        isFetchingCommunityProperty: false,
      };

    //SEPARATE PROPERTY
    case "REQUEST_SEPARATE_PROPERTY":
      return { ...state, isFetchingSeparateProperty: true };
    case "SUCCESS_SEPARATE_PROPERTY":
      return {
        ...state,
        isFetchingSeparateProperty: false,
        separateProperty: {
          no: {
            separatePropertyStatus: action.payload.separateProperty,
          },
          yes: {
            useLanguage: action.payload.separateUseLanguage,
          },
        },
      };

    case "ERROR_SEPARATE_PROPERTY":
      return { ...state, isFetchingSeparateProperty: false };

    //CHILD CUSTODY RIGHTS
    case "REQUEST_CHILD_CUSTODY_RIGHT":
      return { ...state, isFetchingChildCustodyRight: true };
    case "SUCCESS_CHILD_CUSTODY_RIGHT":
      return {
        ...state,
        isFetchingChildCustodyRight: false,
        custodyRights: {
          custodyRightsStatus: action.payload.childCustodyRight,
        },
      };

    case "ERROR_CHILD_CUSTODY_RIGHT":
      return { ...state, isFetchingChildCustodyRight: false };

    //DOMESTIC VIOLENCE
    case "REQUEST_DOMESTIC_VIOLENCE":
      return { ...state, isFetchingDomesticViolence: true };
    case "SUCCESS_DOMESTIC_VIOLENCE":
      return {
        ...state,
        isFetchingDomesticViolence: false,
        domesticVoilence: {
          domesticVoilenceStatus: action.payload.domesticViolence,
        },
      };

    case "ERROR_DOMESTIC_VIOLENCE":
      return { ...state, isFetchingDomesticViolence: false };

    //CHILD CUSTODY CASE
    case "REQUEST_CHILD_CUSTODY_CASE":
      return { ...state, isFetchingChildCustodyCase: true };
    case "SUCCESS_CHILD_CUSTODY_CASE":
      return {
        ...state,
        isFetchingChildCustodyCase: false,
        childCustodyCase: {
          childCustodyCaseStatus: action.payload.childCustody,
        },
      };

    case "ERROR_CHILD_CUSTODY_CASE":
      return { ...state, isFetchingChildCustodyCase: false };

    //DATES

    case "REQUEST_DATES":
      return { ...state, isFetchingDates: true };
    case "SUCCESS_DATES":
      return {
        ...state,
        isFetchingDates: false,
        dates: {
          dateOfMarriage: action.payload.dateofMarriage,
          dateOfSeparation: action.payload.dateofSepration,
          dateOfDP: action.payload.dateOfDP,
          dateOfDPSeparation: action.payload.dateOfDPSeparation,
        },
      };

    case "ERROR_DATES":
      return { ...state, isFetchingDates: false };

    case "REQUEST_RESPONDANT_FILLING_OPTION":
      return { ...state, isFetchingRespondantFillingOptions: true };
    case "SUCCESS_RESPONDANT_FILLING_OPTION":
      return {
        ...state,
        isFetchingRespondantFillingOptions: false,
        filingOption: {
          filingOptionStatus: action.payload.filingOptionTypes,
          divorce: {
            divorcedTypes: action.payload.divorceBase,
          },
          legalSeparation: {
            legalSeparationTypes: action.payload.legalSeparationBase,
          },
          nulity: action.payload.groundNullity,
        },
      };
    case "ERROR_RESPONDANT_FILLING_OPTION":
      return { ...state, isFetchingRespondantFillingOptions: false };

    //MarriedBefore

    case "REQUEST_MARRIED_BEFORE":
      return { ...state, isMarriedBefore: true };
    case "SUCCESS_MARRIED_BEFORE":
      return {
        ...state,
        isMarriedBefore: false,
        marriedBefore: {
          marriedBeforeStatus: action.payload.marriedBeforeStatus,
        },
      };
    case "ERROR_MARRIED_BEFORE":
      return { ...state, isMarriedBefore: false };

    //DenyingDissolvingMarriage

    case "REQUEST_DENYING_DISSOLVING_MARRIAGE":
      return { ...state, isFetchingDenyingDissolvingMarriage: true };
    case "SUCCESS_DENYING_DISSOLVING_MARRIAGE":
      return {
        ...state,
        dissolveMarriage: {
          dissolveMarriageStatus: action.payload.denyingMarriageCheck,
        },
        isFetchingDenyingDissolvingMarriage: false,
      };

    case "ERROR_DENYING_DISSOLVING_MARRIAGE":
      return { ...state, isFetchingDenyingDissolvingMarriage: false };

    //RespondantFiledPetition

    case "REQUEST_RESPONDANT_FILLED_PETITION":
      return { ...state, isFetchingRespondantFiledPetition: true };
    case "SUCCESS_RESPONDANT_FILLED_PETITION":
      return {
        ...state,
        isFetchingRespondantFiledPetition: false,

        respondantDissolutionOfMarriage: {
          no: {
            respondantDissolutionOfMarriageStatus:
              action.payload.dissolutionOfMarriageStatus,
          },
          yes: {
            caseNo: action.payload.caseNo,
          },
        },
      };

    case "ERROR_RESPONDANT_FILLED_PETITION":
      return { ...state, isFetchingRespondantFiledPetition: false };

    //ADD FORMS
    case "REQUEST_ADD_FORMS":
      return { ...state, isFetchingAddForms: true };
    case "SUCCESS_ADD_FORMS":
      return { ...state, isFetchingAddForms: false };

    case "ERROR_ADD_FORMS":
      return { ...state, isFetchingAddForms: false };

    //ADD SUPPOUSAL SUPPORT

    case "REQUEST_ADD_SUPPOUSAL":
      return { ...state, isFetchingAddSppousalSupport: true };
    case "SUCCESS_ADD_SUPPOUSAL":
      return {
        ...state,
        spousalSupport: {
          spousalSupportPayable: {
            spousalSupportPayableStatus: action.payload.payableSs,
          },
          spousalSupportTerminate: {
            spousalSupportTerminateStatus: action.payload.courtAbilityAward,
          },
          spousalSupportReserve: {
            spousalSupportReserveStatus: action.payload.reserveRightsSs,
          },
        },
        isFetchingAddSppousalSupport: false,
      };

    case "ERROR_ADD_SUPPOUSAL":
      return { ...state, isFetchingAddSppousalSupport: false };

    //ADD CUSTODIES
    case "REQUEST_ADD_CUSTODY":
      return { ...state, isFetchingAddCustody: true };
    case "SUCCESS_ADD_CUSTODY":
      return {
        ...state,
        isFetchingAddCustody: false,
        childCustody: {
          legalCustody: action.payload.legalCustody,
          physicalCustody: action.payload.physicalCustody,
          childVisitation: action.payload.childVisitation,
          additionalForm: action.payload.additionalForm,
        },
      };

    case "ERROR_ADD_CUSTODY":
      return { ...state, isFetchingAddCustody: false };

    //FORMER_LAST_NAME
    case "REQUEST_FORMER_LAST_NAME":
      return { ...state, isFetchingFormerLastName: true };
    case "SUCCESS_FORMER_LAST_NAME":
      console.log(action.payload,"payloadddddddd")
      return {
        ...state,
        isFetchingFormerLastName: false,
        restoreFormerLastName: {
          no: {
            restore_name_res: action.payload.restoreName,
          },
          yes: {
            name_response: action.payload.name_response,
            name_petitioner:state.restoreFormerLastName.yes.name_petitioner
          },
        },
      };

    case "ERROR_FORMER_LAST_NAME":
      return { ...state, isFetchingFormerLastName: false };

    //CHILD RESIDENCE
    case "REQUEST_CHILD_RESIDENCE":
      return { ...state, isFetchingChildResidence: true };
    case "SUCCESS_CHILD_RESIDENCE":
      return {
        ...state,
        isFetchingChildResidence: false,
      };

    case "ERROR_CHILD_RESIDENCE":
      return { ...state, isFetchingChildResidence: false };

    //CHILD AGE
    case "RP_REQUEST_CHILD_AGE":
      return { ...state, isFetchingChildAge: true };
    case "RP_SUCCESS_CHILD_AGE":
      return {
        ...state,
        isFetchingChildAge: false,

        underAge18 : action.payload.respondentChildUnder18,
      };

    case "RP_ERROR_CHILD_AGE":
      return { ...state, isFetchingChildAge: false };

    //UPDATE DATA

    case "REQUEST_UPDATE_DATA":
      return { ...state, isUpdatingData: true };
    case "SUCCESS_UPDATE_DATA":
      return {
        ...state,
        isUpdatingData: false,
        petitionerDetails: {
          firstName: action.payload.petitionerFirstName,
          lastName: action.payload.petitionerLastName,
          streetAddress: action.payload.petitionerAddress,
          city: action.payload.petitionerCity,
          zip: action.payload.petitionerZip,
          state: action.payload.petitionerState,
          telephone: action.payload.petitionerTelephoneNo,
          email: action.payload.petitionerEmail,
        },
        respondentDetails: {
          firstName: action.payload.spouseFirstName,
          lastName: action.payload.spouseLastName,
          streetAddress: action.payload.spouseAddress,
          city: action.payload.spouseCity,
          zip: action.payload.spouseZip,
          state: action.payload.spouseState,
          telephone: action.payload.spouseTelephoneNo,
          email: action.payload.spouseEmail,
        },
        court: {
          courtStreetAddress: action.payload.courtStreetAddress,
          courtMailingAddress: action.payload.courtMailingAddress,
          city: action.payload.courtCity,
          zip: action.payload.courtZip,
          branch: action.payload.courtBranch,
          county: action.payload.county,
        },
      };

    case "ERROR_UPDATE_DATA":
      return { ...state, isUpdatingData: false };

    //CUSTODY TYPES
    case "REQUEST_CUSTODY_TYPES":
      return { ...state, isFetchingCustodyTypes: true };
    case "SUCCESS_CUSTODY_TYPES":
      return { ...state, isFetchingCustodyTypes: false };

    case "ERROR_CUSTODY_TYPES":
      return { ...state, isFetchingCustodyTypes: false };

    //CUSTODY SUBTYPES

    case "REQUEST_CUSTODY_SUBTYPES":
      return { ...state, isFetchingCustodySubtypes: true };
    case "SUCCESS_CUSTODY_SUBTYPES":
      return { ...state, isFetchingCustodySubtypes: false };

    case "ERROR_CUSTODY_SUBTYPES":
      return { ...state, isFetchingCustodySubtypes: false };

    //DOMESTIC_PARTNERSHIP

    case "REQUEST_DOMESTIC_PARTNERSHIP":
      return { ...state, isFetchingDPDetails: true };
    case "SUCCESS_DOMESTIC_PARTNERSHIP":
      return {
        isFetchingDPDetails: false,
        ...state,
        domesticPartnership: {
          domesticPartnershipStatus:action.payload.isDp,
          establishedInCalifornia: {
            establishedInCaliforniaStatus:action.payload.domesticPartnershipInCalifornia,
              californiaJurisdiction:{
                petitionerState:action.payload.petitionerLive,
                respondentState:action.payload.respondantLive
            }
          }
        },

      };

    case "ERROR_DOMESTIC_PARTNERSHIP":
      return { ...state, isFetchingDPDetails: false };

    case "SUCCESS_DIVORCE":
      return { ...state, divorceId: action.payload.divorce_id };
    case "REQUEST_FILLING_OPTION":
      return { ...state, isFetchingOption: true };
    case "SUCCESS_FILLING_OPTION":
      //STOP SPINNER & Show Data
      return {
        ...state,
        fillingOption: action.payload,
        isFetchingOption: false,
      };
    //Spinner and ERROR
    case "ERROR_FILLING_OPTION":
      return {
        ...state,
        isFetchingOption: false,
      };

    case "REQUEST_STATES":
      return { ...state, isFetchingStates: true };
    case "SUCCESS_STATES":
      //STOP SPINNER & Show Data
      return { ...state, states: action.payload, isFetchingStates: false };
    //Spinner and ERROR
    case "ERROR_STATES":
      return { ...state, isLogin: true, isFetchingStates: false };

    case "REQUEST_DIVORCE_LS":
      return { ...state, isFetchingdivorceLsBasis: true };
    case "SUCCESS_DIVORCE_LS":
      //STOP SPINNER & Show Data
      return {
        ...state,
        divorceLsBasis: action.payload,
        isFetchingdivorceLsBasis: false,
      };
    //Spinner and ERROR
    case "ERROR_DIVORCE_LS":
      return { ...state, isFetchingdivorceLsBasis: false };

    case "REQUEST_NULLITY":
      //STOP SPINNER & Show Data
      return { ...state, isFetchingNullityBasis: true };
    //Spinner and ERROR
    case "SUCCESS_NULLITY":
      return {
        ...state,
        nullityBasis: action.payload,
        isFetchingNullityBasis: false,
      };
    case "ERROR_NULLITY":
      //STOP SPINNER & Show Data
      return {
        ...state,
        nullityBasis: action.payload,
        isFetchingNullityBasis: false,
      };
    default:
      return state;
  }
};

export default responsePacketReducer;